
// Types for BroCode functionality
export interface BroData {
  id: string;
  wallet_address: string;
  brocode: string;
  brocode_prefix: string;
  rank: string;
  bro_score: number;
  initiated: boolean;
  is_brometheus: boolean;
  xp_cost: number;
  created_at: string;
  twitter_handle?: string;
}

export interface RerollResult {
  success: boolean;
  brocode?: string;
  error?: string;
}

export interface CipherResult {
  success: boolean;
  brocode?: string;
  error?: string;
}

export interface RankUpgradeResult {
  success: boolean;
  newRank?: string;
  error?: string;
}

// 🚨 ARCHIVED: Old static prefix arrays - now handled by complete-initiation edge function
// These are preserved for reference but should not be used for new onboarding
// All new BroCode generation uses the BROCODE_META system in the edge function

// 🚨 LEGACY: BroCode prefixes pool (DEPRECATED - use complete-initiation edge function)
export const BROCODE_PREFIXES_LEGACY = [
  "WIFESNIPER", "NPCDRIP", "DOOMCYCLE", "CLUELESSMAXX", "PRIMALCOPE",
  "CHADFAIL", "MEMEMANCER", "BRODRAIN", "DEATHAPE", "RAWDUMPER",
  "VESTFARMER", "STIMSTACK", "INFLUENZO", "GRIFTPORT", "FAPSHAKER",
  "SOYSWAP", "DEGENFORCE", "CLICKMAXX", "BROTASIS"
];

// 🚨 LEGACY: Social Bro specific prefixes (DEPRECATED - use complete-initiation edge function)
export const SOCIAL_BRO_PREFIXES_LEGACY = [
  "SOCIAL", "TWEET", "VIRAL", "SHARE", "BOOST", 
  "ENGAGE", "CONNECT", "NETWORK", "TREND", "BUZZ"
];

// ✅ ACTIVE: Valid ranks in the system (still used for validation)
export const VALID_RANKS = [
  "Shadow Bro",
  "Initiated Bro", 
  "Social Bro",
  "Liquidity Bro",
  "BROMETHEUS"
];

// ✅ ACTIVE: Helper function to check if a rank is valid
export const isValidRank = (rank: string): boolean => {
  return VALID_RANKS.includes(rank);
};

// ✅ ACTIVE: Helper function to check if a rank is Social Bro
export const isSocialBro = (rank: string): boolean => {
  return rank === "Social Bro";
};

// ✅ ACTIVE: Helper function to check if a rank is Liquidity Bro
export const isLiquidityBro = (rank: string): boolean => {
  return rank === "Liquidity Bro";
};

// ✅ ACTIVE: Helper function to check if a rank is Shadow Bro
export const isShadowBro = (rank: string): boolean => {
  return rank === "Shadow Bro";
};

// ✅ ACTIVE: Helper function to check if a user is BROMETHEUS
export const isBrometheus = (rank: string): boolean => {
  return rank === "BROMETHEUS";
};
